import { isPublicRoute as isPublicRouteUtil, isNotFoundRoute as isNotFoundRouteUtil } from "@surgia/utils";

export const ADMIN_PUBLIC_ROUTES = {
  LOGIN: "/login",
  WRONG_PORTAL: "/wrong-portal",
  NOT_FOUND: "*",
} as const;

export const ADMIN_PROTECTED_ROUTES = {
  HOME: "/",
  DASHBOARD: "/dashboard",
  TENANTS: "/tenants",
  USERS: "/users",
  CATALOG: "/catalog",
  PURCHASE_ORDERS: "/purchase-orders", 
  TENANT_DETAILS: "/tenants/:id",
  PRODUCT_ASSIGNMENT: "/tenants/:id/product-assignment",
  TENANT_DETAILS_BRANCHES: "/tenants/:id/branches",
  TENANT_DETAILS_USERS: "/tenants/:id/users",
  TENANT_DETAILS_USER_DETAILS: "/tenants/:tenantId/users/:userId",
  TENANT_DETAILS_CATALOG: "/tenants/:id/catalog",
  TENANT_DETAILS_PURCHASE_ORDERS: "/tenants/:id/purchase-orders",
  TENANT_DETAILS_PURCHASE_ORDER_DETAILS: "/tenants/:id/purchase-orders/:poId",
  TENANT_DETAILS_PURCHASE_REQUESTS: "/tenants/:id/purchase-requests",
  PRODUCT_DETAILS: "/tenants/:id/:tenantName/product_details/:productId/edit",
} as const;

export const isPublicRoute = (pathname: string): boolean => {
  return isPublicRouteUtil(pathname, ADMIN_PUBLIC_ROUTES);
};

export const isNotFoundRoute = (pathname: string): boolean => {
  return isNotFoundRouteUtil(pathname, ADMIN_PUBLIC_ROUTES, ADMIN_PROTECTED_ROUTES);
};